<template>
  <div class="batch-resource-upload">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>批量上传资源</span>
        <el-button style="float: right; padding: 3px 10px" type="text" @click="$router.push('/resources')">
          返回资源列表
        </el-button>
      </div>

      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="所属分类" required>
          <el-select v-model="form.category_id" placeholder="请选择三级分类" style="width: 100%">
            <el-option
              v-for="category in level3Categories"
              :key="category.id"
              :label="category.title"
              :value="category.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="媒体类型" required>
          <el-radio-group v-model="form.media_type">
            <el-radio :label="1">图片</el-radio>
            <el-radio :label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="上传文件">
          <el-upload
            action="#"
            :http-request="handleCustomUpload"
            :multiple="true"
            :show-file-list="true"
            :file-list="fileList">
            <el-button size="small" type="primary">选择多个文件</el-button>
            <div slot="tip" class="el-upload__tip">
              可选择多个图片或视频文件，类型以上方选择为准
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="链接列表">
          <el-input
            type="textarea"
            v-model="form.link_text"
            :rows="5"
            placeholder="每行一条图片或视频链接，可与上方“上传文件”混合使用">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">提交</el-button>
          <el-button @click="$router.push('/resources')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { categoryApi, resourceApi, uploadApi } from '@/api'

export default {
  name: 'BatchResourceUpload',
  data() {
    return {
      level3Categories: [],
      fileList: [],
      submitting: false,
      form: {
        category_id: null,
        media_type: 1, // 1 图片，2 视频
        link_text: '' // 多个链接，每行一条
      }
    }
  },
  mounted() {
    this.loadLevel3Categories()
  },
  methods: {
    async loadLevel3Categories() {
      try {
        const response = await categoryApi.getAll({ level: 3 })
        this.level3Categories = Array.isArray(response)
          ? response.sort((a, b) => a.sort - b.sort)
          : []
      } catch (error) {
        this.$message.error('加载三级分类失败: ' + error.message)
      }
    },
    async handleCustomUpload(options) {
      try {
        const response = await uploadApi.uploadFile(options.file)

        let fileUrl
        if (typeof response === 'string') {
          fileUrl = response
        } else if (response && response.url) {
          fileUrl = response.url
        } else if (response && response.data) {
          fileUrl = typeof response.data === 'string' ? response.data : response.data.url
        } else {
          fileUrl = response
        }

        options.file.url = fileUrl
        options.onSuccess && options.onSuccess(response, options.file)
        this.fileList = [...this.fileList, options.file]
      } catch (error) {
        options.onError && options.onError(error)
        this.$message.error(`文件 ${options.file.name} 上传失败: ${error.message || '未知错误'}`)
      }
    },
    async handleSubmit() {
      if (!this.form.category_id) {
        this.$message.error('请选择所属分类')
        return
      }

      const resources = []

      // 来自上传文件的资源
      this.fileList.forEach(file => {
        if (file.url) {
          resources.push({
            categoryId: this.form.category_id,
            mediaUrl: file.url,
            mediaType: this.form.media_type,
            sort: 0
          })
        }
      })

      // 来自链接文本的资源
      if (this.form.link_text) {
        this.form.link_text
          .split('\n')
          .map(line => line.trim())
          .filter(line => !!line)
          .forEach(url => {
            resources.push({
              categoryId: this.form.category_id,
              mediaUrl: url,
              mediaType: this.form.media_type,
              sort: 0
            })
          })
      }

      if (resources.length === 0) {
        this.$message.error('请至少上传一个文件或填写一个链接')
        return
      }

      try {
        this.submitting = true
        await resourceApi.create(resources)
        this.$message.success('批量上传成功')
        this.$router.push('/resources')
      } catch (error) {
        this.$message.error('批量上传失败: ' + error.message)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.batch-resource-upload {
  padding: 20px;
}
</style>


